import React from "react";
import SignIn from "../components/SignIn";
import SignPrivacyNotice from "../components/SignPrivacyNotice";

const SignPrivacyNoticeScreen = (props) => {
  return <SignPrivacyNotice {...props} />;
};
export default SignPrivacyNoticeScreen;
